// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4n-2";
export var blackBorderOnHover = "_4n-7";
export var cell = "_4n-6";
export var cellContainer = "_4n-3";
export var checked = "_4n-8";
export var disabled = "_4n-5";
export var featuredIconCellContainer = "_4n-9";
export var featuredIconTextContainer = "_4n-b";
export var featuredIconWrapper = "_4n-a";
export var noBorder = "_4n-c";
export var orangeSelectedRow = "_c4-3";
export var overflowableText = "_4n-0";
export var overflowableTextContainer = "_4n-1";
export var row = "_4j-0";
export var rowCheckboxCell = "_4n-4";
export var selectableTable = "_c4-2";